export * from './favorites';
export * from './palettes';
export * from './routes';

export const AI_GENERATION_APP_ID = 'homeowner-app';
